<template>
  <div class="mb-1">
    <aha-icon
      name="meta-key"
      v-if="isCommandKey"
    />
    <aha-icon
      name="ctrl-key"
      v-if="isControlKey"
    />
    <aha-icon
      name="shift-key"
      v-if="hasShiftKey"
      class="ml-1"
    />
    <aha-icon
      v-if="keyName"
      :name="keyName"
      class="ml-1"
    />
  </div>
</template>

<script>
import utils from '@/util'

export default {
  props: {
    keyName: {
      type: String,
      default: '',
    },
    hasControlKeys: {
      type: Boolean,
      default: true,
    },
    hasShiftKey: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isCommandKey() {
      return utils.isMacOS() && this.hasControlKeys
    },
    isControlKey() {
      return !utils.isMacOS() && this.hasControlKeys
    },
  },
}
</script>
